import { cn } from "@/tiptap/lib/tiptap-utils"

function Textarea({
  className,
  ...props
}) {
  return (<textarea data-slot="textarea" className={cn("textarea", className)} {...props} />);
}

export { Textarea }
